import { render, staticRenderFns } from "./CertificatePreview.vue?vue&type=template&id=7bc8c138&scoped=true"
import script from "./CertificatePreview.vue?vue&type=script&lang=js"
export * from "./CertificatePreview.vue?vue&type=script&lang=js"
import style0 from "./CertificatePreview.vue?vue&type=style&index=0&id=7bc8c138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc8c138",
  null
  
)

export default component.exports